var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friend-list-container",class:{'default': !_vm.hasFriend}},[(_vm.hasFriend)?_c('div',_vm._l((_vm.friendList),function(friend){return _c('friend-item',{key:friend.userID,attrs:{"friend":friend}})}),1):_c('div',{staticStyle:{"color":"gray"}},[_vm._v("暂无好友")])])
}
var staticRenderFns = []

export { render, staticRenderFns }